/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export class LoadAppConfig {
    static readonly type = '[AppConfig] Load AppConfig';
}

export class AppConfigLoaded {
    static readonly type = '[AppConfig] AppConfig loaded';
}
